<template>
  <div class="busi-page ctn">
    <h1>业务板块</h1>
    <ul>
      <li @click="go('/Busi1')">
        <h3>智电设计服务</h3>
        <a href="#/Busi1">了解详情 +</a>
      </li>
      <li @click="go('/Busi2')">
        <h3>智能配网服务</h3>
        <a href="#/Busi2">了解详情 +</a>
      </li>
      <li @click="go('/Busi3')">
        <h3>智慧运营服务</h3>
        <a href="#/Busi3">了解详情 +</a>
      </li>
      <li @click="go('/Busi5')">
        <h3>绿电低碳服务</h3>
        <a href="#/Busi5">了解详情 +</a>
      </li>
      <li @click="go('/Busi4')">
        <h3>智慧产品服务</h3>
        <a href="#/Busi4">了解详情 +</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    go(u) {
      this.$router.push(u)
    }
  }
}
</script>
